var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 6.2 17.8 1.5 12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12ZM5.35 18.65C4.88 18.18 4.88 17.42 5.35 16.95L9.06 13.24L9.63 13.81L10.16 13.28L10.98 12.46L8.75 10.23C7.79 10.62 6.66 10.44 5.89 9.67C5.12 8.9 4.92999 7.77 5.32999 6.81L6.49 7.97C6.89 8.37 7.55 8.37 7.96 7.97C8.36 7.57 8.36 6.91 7.96 6.5L6.8 5.34C7.76 4.95 8.89 5.12999 9.66 5.89999C10.43 6.66999 10.62 7.79999 10.22 8.75999L12.45 10.99L15.92 7.52L15.53 7.13C15.43 7.03 15.43 6.85999 15.53 6.75999L17.22 5.07C17.32 4.97 17.49 4.97 17.59 5.07L18.92 6.39999C19.02 6.49999 19.02 6.67 18.92 6.77L17.23 8.45999C17.13 8.55999 16.96 8.55999 16.86 8.45999L16.47 8.06999L13 11.54L15.23 13.77C16.19 13.38 17.32 13.56 18.09 14.33C18.86 15.1 19.05 16.23 18.65 17.19L17.49 16.03C17.09 15.63 16.43 15.63 16.02 16.03C15.62 16.43 15.62 17.09 16.02 17.5L17.18 18.66C16.22 19.05 15.09 18.87 14.32 18.1C13.55 17.33 13.36 16.2 13.76 15.24L11.53 13.01L10.17 14.37L10.74 14.94L7.03 18.65C6.56 19.12 5.8 19.12 5.34 18.65H5.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipment);
export default __webpack_public_path__ + "static/media/ic-equipment.12ad8b31bc66f21a0e49564467dc3639.svg";
export { ForwardRef as ReactComponent };